import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { autoinject, computedFrom } from "aurelia-framework";
import { I18N } from "aurelia-i18n";
import { Reflection } from "../../../../../../utilities/reflection";

export interface ImportExcelNoteDialogModel {
	onCancel?: () => void,
	onSave?: (note: string) => void,
	note?: string,
	isReadOnly: boolean,
}

@autoinject
export class ImportExcelNoteDialog implements ImportExcelNoteDialogModel {
	public onCancel: () => void;
	public onSave: (note: string) => void;
	public note: string;
	public isReadOnly: boolean;

	@computedFrom(Reflection.getPropertyPath<ImportExcelNoteDialogModel>(z => z.isReadOnly))
	get title(): string {
		return this.i18N.tr(this.isReadOnly ? 'add-note-text' : 'notes-text');
	}

	constructor(private dialogClientService: DialogClientService, private i18N: I18N) {

	}

	activate(params: ImportExcelNoteDialogModel) {
		this.onCancel = params.onCancel;
		this.onSave = params.onSave;
		this.note = params.note;
		this.isReadOnly = params.isReadOnly;
	}

	save() {
		if (this.onSave) {
			this.onSave(this.note);
		}

		this.dialogClientService.hide();
	}

	cancel() {
		if (this.onCancel) {
			this.onCancel();
		}

		this.dialogClientService.hide();
	}
}
